import * as angular from 'angular';
import { StateService } from '@uirouter/core';

class HelpPageController implements ng.IComponentController {
    static $inject = ['$state', 'retailerServiceUrl'];

    exampleCsvUrl: string;
    templateCsvUrl: string;
    exampleCsvUrl_food_bev: string;
    templateCsvUrl_food_bev: string;

    constructor (private readonly $state: StateService, retailerApiUrl: string) {
        this.exampleCsvUrl = `${retailerApiUrl}content/products_example.csv`;
        this.templateCsvUrl = `${retailerApiUrl}content/products_template.csv`;
        this.exampleCsvUrl_food_bev = `${retailerApiUrl}content/products_example_food_bev.csv`;
        this.templateCsvUrl_food_bev = `${retailerApiUrl}content/products_template_food_bev.csv`;
    }

    goToProductsImport() {
        this.$state.go('app.operations');
    }
}

angular
    .module('naut')
    .component('helpPage', {
        controller: HelpPageController,
        template: require('./help-page.component.html')
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/inventory/components/help-page/help-page.component.ts